import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import { sendSMSComOffer } from "../accounting/operations.js";
import {
  addLegalEntity,
  checkTariffs,
  createService,
  deleteLegalEntity,
  editLegalEntity,
  getAllServices,
  getLegalEntities,
  // getServiceDetails,
  updateService,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const serviceSlice = createSlice({
  name: "service",
  initialState: initialState.service,
  reducers: {
    setSelectedServiceInSettingsId: (state, action) => {
      state.selectedServiceInSettingsId = action.payload;
    },
    setTariffsModalOpen: (state, action) => {
      state.tariffsModalOpen = action.payload;
    },
    setInactiveTariffDays: (state, action) => {
      state.inactiveTariffDays = action.payload;
    },
  },
  extraReducers: builder =>
    builder

      // Get all services +
      .addCase(getAllServices.pending, handlePending)
      .addCase(getAllServices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.services = action.payload;
      })
      .addCase(getAllServices.rejected, handleRejected)

      // Check Tariffs +
      .addCase(checkTariffs.pending, state => {
        state.isCheckTariffsLoading = true;
        state.error = null;
      })
      .addCase(checkTariffs.fulfilled, (state, action) => {
        state.isCheckTariffsLoading = false;
        state.tariffsInfo = action.payload;
      })
      .addCase(checkTariffs.rejected, (state, action) => {
        state.isCheckTariffsLoading = false;
        state.error = action.payload;
      })

      // Get chosen service details +
      // .addCase(getServiceDetails.pending, handlePending)
      // .addCase(getServiceDetails.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.particularService = action.payload;
      // })
      // .addCase(getServiceDetails.rejected, handleRejected)

      // Create new service +
      .addCase(createService.pending, handlePending)
      .addCase(createService.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.services.push(action.meta.arg);
        state.services.push(action.payload);
      })
      .addCase(createService.rejected, handleRejected)

      // Update service data +
      .addCase(updateService.pending, handlePending)
      .addCase(updateService.fulfilled, (state, action) => {
        state.isLoading = false;
        const serviceToEditIndex = state.services.findIndex(
          service => service.id === action.payload.id
        );
        state.services[serviceToEditIndex] = {
          ...state.services[serviceToEditIndex], // Залишаємо старі дані
          ...action.payload, // Додаємо дані, які відправляли
        };
      })
      .addCase(updateService.rejected, handleRejected)

      // Get all legal entities of the service +
      .addCase(getLegalEntities.pending, handlePending)
      .addCase(getLegalEntities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.legalEntities = action.payload;
      })
      .addCase(getLegalEntities.rejected, handleRejected)

      // Add Legal Entity to the service +
      .addCase(addLegalEntity.pending, handlePending)
      .addCase(addLegalEntity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.legalEntities.push(action.payload);
      })
      .addCase(addLegalEntity.rejected, handleRejected)

      // Edit legal entity of the service +
      .addCase(editLegalEntity.pending, handlePending)
      .addCase(editLegalEntity.fulfilled, (state, action) => {
        state.isLoading = false;
        const orgIndex = state.legalEntities.findIndex(
          org => org.id === action.payload.id
        );

        state.legalEntities[orgIndex] = {
          ...state.legalEntities[orgIndex], // Залишаємо старі дані
          ...action.payload,
        };
      })
      .addCase(editLegalEntity.rejected, handleRejected)

      // Delete legal entity of the service +
      .addCase(deleteLegalEntity.pending, handlePending)
      .addCase(deleteLegalEntity.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteLegalEntity.rejected, handleRejected)

      // Update service balance after SMS send
      .addCase(sendSMSComOffer.fulfilled, (state, action) => {
        const { service_id, new_balance } = action.payload;
        const service = state.services.find(s => s.id === service_id);
        if (service && new_balance !== undefined) {
          service.balance = new_balance;
        }
      }),
});

export const {
  setSelectedServiceInSettingsId,
  setTariffsModalOpen,
  setInactiveTariffDays,
} = serviceSlice.actions;

export default serviceSlice.reducer;
